import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=053f43a2&scoped=true&"
import script from "./CategoryEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEdit.vue?vue&type=style&index=0&id=053f43a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f43a2",
  null
  
)

export default component.exports